<p-confirmDialog />
<h3 class="with-manual-link">
  <span i18n="@@if">Wenn</span>
  <app-manual-link
    href="https://reflact.github.io/engine/Handbuch/Nutzeroberfläche/Bot-Verwaltung/Skills/Wenn-Dann"></app-manual-link>
</h3>
<p
  class="text-secondary mt-1 mb-1"
  i18n="@@if-then-description"
>
  Definiere Regeln, die bei einer passenden Bedingung automatisch ausgelöst werden. Als Aktion stehen
  JavaScript-Ausführung oder ein fester Antworttext zur Verfügung.
</p>
<div>
  <div class="row mt-4">
    <div class="col-3">
      <span i18n="@@trigger">Auslöser</span>
    </div>
    <div class="col">
      <p-inputgroup>
        <p-inputgroup-addon>
          <i
            class="ri-sparkling-fill text-primary"
            style="font-size: 1.2rem;"
          ></i>
        </p-inputgroup-addon>
        <input
          pInputText
          type="text"
          i18n-placeholder="@@describe-if-heading"
          placeholder="Wann soll die KI reagieren?"
          [(ngModel)]="this.customToolKitDescription"
          [ngModelOptions]="{updateOn: 'change'}"
          fluid
        >
      </p-inputgroup>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-3"></div>
    <div class="col-3">
      <p-button
        [disabled]="this.checkForAdding()"
        (onClick)="this.addCustomToolKit()"
        icon="ri ri-add-line"
        label="Hinzufügen"
        i18n-label="@@add"
        size="small"
      />
    </div>
  </div>
</div>
@if (this.customToolKits.length > 0) {
<h5
  class="mt-5"
  i18n="@@if-then-overview"
>Wenn-Dann-Regeln im Überblick</h5>
}
@if (this.customToolKits.length > 0) {
<p-table
  dataKey="id"
  [(selection)]="selectedCustomToolKits"
  [value]="this.customToolKits"
  [rowHover]="true"
  styleClass="p-datatable-sm"
>
  <ng-template pTemplate="header">
    <tr>
      <th class="bot-selection-cell"><p-tableHeaderCheckbox ariaLabel="Alle auswählen" i18n-ariaLabel="@@bulk-select-all" /></th>
      <th i18n="@@status">Status</th>
      <th i18n="@@trigger">Auslöser</th>
      <th i18n="@@skillid">Skill ID</th>
      <th i18n="@@skill-usage-column">Stage-Zuordnung</th>
      <th i18n="@@onoff">Aus/An</th>
      <th i18n="@@actions">Aktionen</th>
    </tr>
  </ng-template>
  <ng-template
    pTemplate="body"
    let-custom
  >
    <tr>
      <td class="bot-selection-cell"><p-tableCheckbox [value]="custom" [ariaLabel]="custom.description" /></td>
      <td style="width: 4rem;">
        @for (i of [].constructor(this.skillService.getSkillDepth(custom.skillId)); track i; let idx = $index; let count
        = $count) {
        <i
          class="ri-corner-down-right-line text-secondary ms-2"
          [ngStyle]="{ 'opacity': idx === count - 1 ? 1 : 0 }"
        ></i>
        }

        @if (custom.enabled) {
        <i class="ri-circle-fill text-primary me-2"></i>
        }
        @if (!custom.enabled) {
        <i class="ri-circle-line text-secondary me-2"></i>
        }

        @if (custom.detectedErrors) {
        <i
          pTooltip="Fehler im JavaScript Code"
          i18n-pTooltip="@@error-js-ifthen"
          class="ri-file-damage-fill text-danger me-2"
        ></i>
        }

        <app-in-place-validator
          [validators]="requiredValidator"
          [text]="custom.description"
        ></app-in-place-validator>
      </td>
      <td>
        <span
          class="fakelink"
          (click)="showDetailDrawer(custom.id)"
        >
          {{ custom.description }}
        </span>
      </td>
      <td style="width:250px">
        <app-skill-id-input
          [value]="custom.skillId"
          [readonly]="false"
          (changed)="custom.skillId = $event; this.rss.saveBotConfigField('toolConfigs')"
        ></app-skill-id-input>
      </td>
      <td>
        <app-skill-usage-list [skillId]="custom.skillId"></app-skill-usage-list>
      </td>
      <td style="width: 0rem;">
        <p-toggleswitch
          [(ngModel)]="custom.enabled"
          (ngModelChange)="this.rss.saveBotConfigField('toolConfigs')"
        ></p-toggleswitch>
      </td>
      <td
        style="width: 2rem;"
        class="text-end"
      >
        <p-menu
          #menu
          appendTo="body"
          [model]="customToolKitContextMenu"
          [popup]="true"
        ></p-menu>

        <p-button
          (onClick)="openCustomToolKitMenu($event, menu, custom)"
          [rounded]="true"
          [text]="true"
          severity="secondary"
          [raised]="true"
          icon="ri ri-more-2-fill"
        ></p-button>
      </td>
    </tr>
  </ng-template>
</p-table>
<app-bulk-action-bar [actions]="bulkActions" [count]="selectedCustomToolKits.length" [allSelected]="allSelected"
  (selectAll)="toggleAll(true)" (clear)="selectedCustomToolKits = []" />
}

@if (detailDrawer) {
<p-drawer
  [(visible)]="this.detailDrawer"
  appendTo="body"
  [position]="'right'"
  [modal]="true"
  [closeOnEscape]="true"
  styleClass="w-100 w-md-75 w-lg-50"
>
  @if (this.selectedToolId) {
  <app-ifthen-tab-detail
    [selectedToolId]="this.selectedToolId"
    (closeDrawer)="this.detailDrawer = false"
  ></app-ifthen-tab-detail>
  }
</p-drawer>
}